import React from "react";
import { PropTypes } from "prop-types";

const Input = ({ onChange, ...rest }) => {
  const handleChange = e => {
    // send to parent
    onChange(e.target.value);
  };

  return (
    <input
      {...rest}
      style={{ border: 0, color: "inherit", padding: "1em" }}
      onChange={handleChange}
    />
  );
};

Input.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default Input;
